@use "../../../../src/styles/Colors.scss" as Colors;
@use "../../../../src/styles/Constants.scss" as Constants;

.icon {
	font-size: Constants.$val-icon64;
	color: Colors.$col-greyInactive;
}

.containerPadded {
	padding: Constants.$val-spacing-s;
}

.centeredRow {
	display: flex;
	justify-content: center;
}

.marginBottom {
	&__m {
		margin-bottom: Constants.$val-spacing-xl;
	}

	&__l {
		margin-bottom: Constants.$val-spacing-xxxl;
	}
}

.titleText {
	color: Colors.$col-greyInactive !important;
	font-weight: 400;
	font-size: Constants.$val-fontSizeXXBig !important;
}

.subtitleText {
	color: Colors.$col-design-gray900 !important;
	margin-bottom: 0 !important;
}